import { UserAgentParser } from './user_agent_parser';
import { pageContext } from './page_context';
import { get } from './get';

/**
 * Get the browser details from the user agent string.
 * @param {String} source - full user agent source string.
 * @returns {Object} browser - the browser the user is currently using
 */
export const parseBrowser = (source) => {
    if (!source) {
        return null;
    }
    const ua = new UserAgentParser();
    ua.Agent.source = source.replace(/^\s*/, '').replace(/\s*$/, '');
    ua.Agent.platform = ua.getPlatform(ua.Agent.source);
    ua.Agent.browser = ua.getBrowser(ua.Agent.source);
    ua.Agent.version = ua.getBrowserVersion(ua.Agent.source);
    ua.testMobile();
    ua.testAndroidTablet();
    ua.testTablet();
    ua.testCompatibilityMode();
    return ua;
};

/**
 * Convenience function for logging messages in the browser's console.
 * @param {String} msg The message to log
 */
export const logMessage = (...msg) => {
    if (process && process.env && process.env.CLIENT && pageContext.inDevMode() && typeof console !== 'undefined'
    ) {
        // eslint-disable-next-line no-console
        console.info(...msg);
    }
};

/**
 * Start the online status check.
 * @param  {Function} dispatch - method used for dispatching actions.
 */
export const startOnlineCheck = (dispatch) => {
    const isOffline = () => {
        const errorPayload = { modalMessage: 'You may be experiencing network issues... Please check your Internet connection and try again.' };
        dispatch({ type: 'SET_CURRENT_ERROR', errorPayload });
    };

    const isOnline = () => {
        dispatch({ type: 'CLEAR_CURRENT_ERROR' });
    };

    if (typeof window !== 'undefined' && window.addEventListener) {
        /**
         * Works well in Firefox and Opera with the Work Off-line option in the File menu.
         * Pulling the ethernet cable doesn't seem to trigger it.
         * Later Google Chrome and Safari seem to trigger it well
         */
        window.addEventListener('offline', isOffline, false);
        window.addEventListener('online', isOnline, false);
    } else if (typeof document !== 'undefined') {
        /**
         * Works in IE with the Work Off-line option in the File menu and pulling the ethernet cable.
         */
        document.body.onoffline = isOffline;
        document.body.ononline = isOnline;
    }
};

/**
 * Creates a URL path including query parameters.
 * For example, it will build the "/some/path?insurance=health" part of this URL http://ctm.com.au/some/path?insurance=health.
 *
 * @param {String} path - A URL path.
 * @param {String} queryString - The raw query / search string eg '?preload=elec.json'
 * @returns {String} URL path including query parameters.
 */
export const getPathWithQueryString = (path = '', queryString) => {
    const qs = queryString || pageContext.getProps().browserHistory.location.search;
    return `${path}${qs}`;
};
